import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { IAssociationSegment } from '../../_models/AssociationSegment';
import {
  Action,
  createAction,
  createReducer,
  props,
  on,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';

export const name = 'associationSegments';

export interface AssociationSegmentState
  extends EntityState<IAssociationSegment> {
  selectedId: number | null;
  isInitialized: boolean;
  loading: boolean;
}

function selectAssociationSegment(a: IAssociationSegment): any {
  return a.id;
}

function sortById(a: IAssociationSegment, b: IAssociationSegment): number {
  if (a.id < b.id) {
    return -1;
  } else if (a.id > b.id) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<IAssociationSegment> =
  createEntityAdapter<IAssociationSegment>({
    selectId: selectAssociationSegment,
    sortComparer: sortById,
  });

const initialState: AssociationSegmentState = adapter.getInitialState({
  selectedId: null,
  isInitialized: false,
  loading: true,
});

/* ACTION */
export const loadAssociationSegmentsAction = createAction(
  '[AssociationSegment] Load AssociationSegments',
  props<{ idPgm: number }>()
);
export const loadAssociationSegmentsSuccessAction = createAction(
  '[AssociationSegment] Load AssociationSegments Success',
  props<{ payload: IAssociationSegment[] }>()
);

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadAssociationSegmentsSuccessAction, (state, { payload }) => {
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      loading: false,
    });
  })
);

export function associationSegmentReducer(
  state: AssociationSegmentState | undefined,
  action: Action
): AssociationSegmentState {
  return reducer(state, action);
}

/* SELECTOR */
const selectAssociationSegmentState =
  createFeatureSelector<AssociationSegmentState>(name);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();
export const selectAllAssociationSegments = createSelector(
  selectAssociationSegmentState,
  selectAll
);

const isInitialized = (state: AssociationSegmentState) => state.isInitialized;
export const selectIsAssociationSegmentInitialized = createSelector(
  selectAssociationSegmentState,
  isInitialized
);
